import * as React from 'react';
import { ReactComponent as ForwardingIconSVG } from '../../assets/icons/mevo/ic_forwarding.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ForwardingIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ForwardingIconSVG} variantPlaces={[1, 2]} {...props} />;
};

export default ForwardingIcon;
